export default "__VITE_ASSET__b053674f__"